const btnFilterManagementBackups = {
  Typography: 'Ningún resultado encontrado'
};

export default btnFilterManagementBackups;
